"use client";

import Link from "next/link";
import type { ComponentProps } from "react";
import { useLocaleHref } from "@/lib/i18n/use-locale-href";

// PASTE #234: a drop-in next/link that keeps in-site navigation Spanish
// on /es pages. It derives the /es prefix from the current URL (via
// useLocaleHref -> usePathname), so it works inside SERVER components
// with zero locale prop-threading, and is a no-op on bare EN + portal
// routes. External / mailto: / tel: / anchor hrefs pass through
// untouched. Object hrefs (rare) pass through unchanged.
type Props = ComponentProps<typeof Link>;

export function LocaleLink({ href, ...rest }: Props) {
  const localeHref = useLocaleHref();
  const resolved = typeof href === "string" ? localeHref(href) : href;
  return <Link href={resolved} {...rest} />;
}
